class UserDeclined extends Error {}

export const askConfirmation = (
  message,
  content = "",
  { icon = "warning", actions = null } = {}
) => {
  const done = new Promise((resolve) =>
    $("#modalConfirm").one("hidden.bs.modal", resolve)
  );
  actions !== null && actions.send("open-modal");
  return new Promise((resolve, reject) =>
    window.showModalConfirm(
      message,
      content,
      icon,
      () => done.then(() => resolve(true)),
      () => done.then(() => reject(new UserDeclined(content))),
      "OK",
      "CANCEL"
    )
  ).finally(() => actions !== null && actions.send("close-modal"));
};

export const mayDecline = (error) => {
  if (error instanceof UserDeclined) return error /*its ok*/;
  throw error;
};
